import { render, staticRenderFns } from "./connectedOffer.vue?vue&type=template&id=554c3529&"
import script from "./connectedOffer.vue?vue&type=script&lang=js&"
export * from "./connectedOffer.vue?vue&type=script&lang=js&"
import style0 from "./connectedOffer.vue?vue&type=style&index=0&id=554c3529&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554c3529')) {
      api.createRecord('554c3529', component.options)
    } else {
      api.reload('554c3529', component.options)
    }
    module.hot.accept("./connectedOffer.vue?vue&type=template&id=554c3529&", function () {
      api.rerender('554c3529', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/connectedOffer.vue"
export default component.exports